import BaseDialog from "components/BaseDialog";
import {DialogBody} from "components/ClosableDialog.styles";
import {useMessages} from "i18n";
import type {GameId} from "./gameCatalog";
import {gameTitle} from "./gamePlayLabel";
import type {TransferGameProps} from "./gameProps";
import {GameStage} from "./GameStage";

type Props = Omit<TransferGameProps, "statusLine"> & {game: GameId; open: boolean; statusLine?: string};

/**
 * The transfer's game in the app's dialog, over the card that offered it (kitecorp/transferify-ui#3320), where it
 * used to open inline and push the card's own content down. Titled with the game's name, and with no ✕ of its own:
 * the game's frame carries one, and so does its placeholder while the chunk loads, which closes the dialog the way
 * Escape and the scrim do. Every way out runs `onClose`, which is what reports the run closed.
 *
 * `statusLine` replaces the mode's default line under a lost round, for a card whose transfer is not still going
 * (the hosted success card's, kitecorp/transferify-ui#3388).
 */
export function GameDialog({open, game, onClose, ...stage}: Props) {
	const {games} = useMessages();
	return (
		<BaseDialog title={gameTitle(games, game)} open={open} onClose={onClose}>
			<DialogBody>
				<GameStage game={game} onClose={onClose} {...stage}/>
			</DialogBody>
		</BaseDialog>
	);
}
